import { ComponentStaticText } from '../i18n.types';
import { XuxGridStaticTextContent } from './xux-grid.staticTextContent.constants';

export const WIDGETS_STATIC_TEXT_CONTENT: {
  [key: string]: ComponentStaticText;
} = {
  xuxGrid: XuxGridStaticTextContent,
};
